type Locales = {
	'de-DE'?: boolean
	'en-AU'?: boolean
	'en-GB'?: boolean
	'en-US'?: boolean
	'es-ES'?: boolean
	'fr-FR'?: boolean
	'it-IT'?: boolean
	'ja-JP'?: boolean
	'pt-PT'?: boolean
	'zh-CN'?: boolean
}

const matchByLocale = (
	currentLocale: string,
	permittedLocales: Locales
): boolean => {
	const isMatch = !!permittedLocales[currentLocale as keyof Locales]

	return isMatch
}

export default matchByLocale
